import { render } from "./SemanticFilter.vue?vue&type=template&id=47368214&scoped=true"
import script from "./SemanticFilter.vue?vue&type=script&lang=js"
export * from "./SemanticFilter.vue?vue&type=script&lang=js"

import "./SemanticFilter.vue?vue&type=style&index=0&id=47368214&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47368214"]])

export default __exports__